import { DataType } from 'src/ports-backend/PostalKit';
import portsApi from '../framework/ports/portsApi';

const PostalKitFrontend = {
  publishEvent: (data: DataType): void => {
    portsApi.invoke('PostalKit.publishEvent', [data]);
  },

  onSubscribe: (callback: Function, args: [string, string]) => {
    return portsApi.on('PostalKit.onSubscribe', callback, args);
  },
};
export default PostalKitFrontend;
